import { Box } from "@mui/material";
import { RHFTextField } from "../../../components/Forms";
import { useMsg } from "../../../components/Msg/Msg";
import { RefreshableChip } from "../../AIRecommendations/RefreshableChip";
import { useListHints } from "../../AIRecommendations/useListHints.hook";
import { useMyQuery } from "../../Authorization/AuthProvider";
import { sessionsMessages } from "../messages";
import { useArea } from "./AreaStep";
import { FormStepCard } from "./FormStepCard";
import { SESSION_FIELDS } from "./constants";

const useGoalAIHintsQuery = ({ areaOfDevelopment }) => {
  return useMyQuery({
    enabled: !!areaOfDevelopment,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    // gcTime: 0,
    queryKey: ["user-sessions", "generate-long-term-goal", areaOfDevelopment],
    fetchDef: {
      method: "POST",
      url: `/api/latest/user-sessions/generate-long-term-goal`,
      payload: { areaOfDevelopment },
    },
  });
};

const HINTS_MOCK = [
  "Vytvořím strategický plán na rozvoj mého podnikání, zaměřený na zvýšení svobody a rovnováhy mezi prací a rodinou, do šesti měsíců.",
  "Do tří měsíců navrhnu tři nové nápady pro zlepšení krásy a řádu v mém pracovním prostředí.",
  "Každý měsíc se zaměřím na jednu novou strategii, která posílí můj pocit sebedůvěry a intelektuální růst.",
  "Do čtyř měsíců zavedu systém, který podporuje čestnost a odpovědnost v mém týmu, čímž podpořím pozitivní pracovní kulturu.",
  "Každý týden budu věnovat čas analýze a zlepšení své komunikační strategie, abych posílil své spojení s rodinou.",
];

const GoalAIRecommendation = ({
  areaOfDevelopment,
  goalValue,
  onHintClick,
}) => {
  const goalAIHintsQuery = useGoalAIHintsQuery({
    areaOfDevelopment,
  });
  // const hints = useGoalHints();
  // const hints = HINTS_MOCK;
  const hints = [].concat(goalAIHintsQuery.data || []);
  const { getHintAt, handleRefreshMaybe } = useListHints({
    hints,
    values: [goalValue],
  });

  return (
    <RefreshableChip
      text={getHintAt(0)}
      onChipClick={onHintClick}
      onRefreshMaybe={handleRefreshMaybe}
      isLoading={goalAIHintsQuery.isLoading}
    />
  );
};

export const GoalStep = ({ step, stepper, data, submitDisabled }) => {
  const msg = useMsg({ dict: sessionsMessages });
  const valueArr = data[SESSION_FIELDS.AREA_OF_DEVELOPMENT];
  const { areaText } = useArea({ valueArr });
  const field = step.fieldDefMap[SESSION_FIELDS.LONG_TERM_GOAL] ?? {};

  return (
    <FormStepCard
      {...{
        step,
        stepper,
        data,
        submitDisabled,
      }}
    >
      {({ form }) => (
        <Box sx={{ mb: 2 }}>
          <RHFTextField
            name={SESSION_FIELDS.LONG_TERM_GOAL}
            rules={{
              required: "Required",
              validate: field.validate,
            }}
            placeholder={msg("sessions.steps.goal.placeholder")}
            autoFocus
            withHelperTextSpace // without this, helper text is intermediately displayed after clicking on a chip, moving ui down, causing missclick
            size="small"
            hiddenLabel
            multiline
            rows={4}
            sx={{ mt: 4, mb: 0 }}
            fullWidth
          />
          <GoalAIRecommendation
            areaOfDevelopment={areaText}
            goalValue={form.watch(SESSION_FIELDS.LONG_TERM_GOAL)}
            onHintClick={({ text }) => {
              form.setValue(SESSION_FIELDS.LONG_TERM_GOAL, text, {
                shouldValidate: true,
              });
            }}
          />
        </Box>
      )}
    </FormStepCard>
  );
};
